/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { CarModelModel } from '../../api/core/core.types';
import {
  GroupBy
} from '../../api/pricing/pricing.types';
import { RateSquareInfo } from './RateSquare';
import { RatesTableElement } from './RatesTableElement';
import RateTooltip from './RateTooltip';

interface RatesOverviewTableProps {
  ratesToBeRendered: any;
  carModels: CarModelModel[];
  maxAmount?: number;
  minAmount?: number;
  startingDate: string;
  endDate: string;
  largestPerDay: number;
  smallestPerDay: number;
  deskCode?: string;
  brokerRateCode?: string;
}

interface RatesOverviewTableState {
  rateSquareInfo: RateSquareInfo | undefined;
  isTooltipOpen: boolean;
  rateInfo: RateSquareInfo | undefined;
  isLoading: boolean;
}

export class RatesOverviewTable extends PureComponent<RatesOverviewTableProps, RatesOverviewTableState> {

  readonly state = {
    rateSquareInfo: undefined,
    isTooltipOpen: false,
    rateInfo: undefined,
    isLoading: false
  };

  getRateTableElements = () => {
    const rateTableElementList: any[] = [];
    const keys: string[] = Array.from(this.props.ratesToBeRendered.keys());

    keys.forEach((key) => {
      const carModel = this.props.carModels.find((cm) => cm.id === Number(key));
      rateTableElementList.push((
        <RatesTableElement
          largestPerDay={this.props.largestPerDay}
          smallestPerDay={this.props.smallestPerDay}
          key={key}
          groupedBy={GroupBy.CAR_MODEL}
          carModel={carModel || undefined}
          rentalDays={0}
          ratePeriods={this.props.ratesToBeRendered.get(key)}
          startingDate={this.props.startingDate}
          endDate={this.props.endDate}
          deskCode={this.props.deskCode}
          brokerRateCode={this.props.brokerRateCode}
          onRateSquareClick={(info: RateSquareInfo) => this.onRateSquareClick(info)}
        />
      ));
    });

    rateTableElementList.sort((a, b) => {
      if (a.props.carModel && b.props.carModel) {
        return this.sortItemsByFieldValue('rank', a, b) || this.sortItemsByFieldValue('acrissCode', a, b) || this.sortItemsByFieldValue('name', a, b) ;
      } else {
        return 0;
      }
    });

    return rateTableElementList;
  };

  sortItemsByFieldValue(field: string, a: any, b: any): number {
    if (!a.props.carModel.rank && !b.props.carModel.rank) {
      return 0;
    } else if (!a.props.carModel.rank) {
      return 1;
    } else if (!b.props.carModel.rank) {
      return -1;
    } else {
      if (typeof a.props.carModel[field] === 'number') {
        return a.props.carModel[field] - b.props.carModel[field];
      } else {
        return a.props.carModel[field].localeCompare(b.props.carModel[field]);
      }
    }
  }

  getTooltipTarget = () => {
    let info;

    if (this.state.rateSquareInfo) info = this.state.rateSquareInfo as unknown as RateSquareInfo;

    if (info) return info.ref;

    return 'tooltip-temp';
  };

  onRateSquareClick = (detailTooltipRateSquareInfo: RateSquareInfo) => {
    this.setState({
      rateSquareInfo: detailTooltipRateSquareInfo,
      isTooltipOpen: true,
      rateInfo: detailTooltipRateSquareInfo
    });
  };

  onBlur = () => {
    this.setState({
      rateSquareInfo: undefined,
      isTooltipOpen: false,
      rateInfo: undefined,
      isLoading: false
    });
  };

  render() {
    return (
      <table id="tooltip-temp" className="rates-overview-table">
        <tbody>
          {this.getRateTableElements().map((rateTableElement: any, index) => <tr key={`${index}${rateTableElement.key}`}>{rateTableElement}</tr>)}
        </tbody>
        <RateTooltip
          rateSquareInfo={this.state.rateSquareInfo}
          isTooltipOpen={this.state.isTooltipOpen}
          rateInfo={this.state.rateInfo}
          isLoading={this.state.isLoading}
          target={this.getTooltipTarget()}
          toggle={this.onBlur}
        />
      </table>
    );
  }

}
